<template>
  <div class="candidate-page">
    <keep-alive>
      <component
        :is="dynamicComponent"
        :candidate="candidate"
        @candidateUpdated="setNewCandidate($event)"
        @intakeNoteUpdated="setIntakeNote($event)"
        @switchPage="switchHandler"
        @unsavedChanges="hasUnsavedChanges($event)"
      />
    </keep-alive>
  </div>
</template>

<script>
  import candidateInformation from "../../components/candidate/candidateInformation"
  import candidateInformationAdditional from "../../components/candidate/candidateInformationAdditional.vue"

  import {candidateCreate} from "../../components/mixins/candidateCreate.js";
  import {swalModals} from "../../components/mixins/swalModals.js";

  export default {
    mixins: [candidateCreate, swalModals],
    components: {
      candidateInformation,
      candidateInformationAdditional,
    },
  }
</script>